<life-di-nav></life-di-nav>
<lifedi-breadcrumb></lifedi-breadcrumb>

<div class="container">
  <div class="row justify-content-center">
    <h1 class="lifedi-color">
      เกี่ยวกับ Life Di
    </h1>
  </div>
  <div class="row mt-5 justify-content-center">
    <mat-card class="m-3">
      <div class="row mt-5 justify-content-center">
        <img src="../../../assets/logo.png" class="mx-auto d-block img-fluid" id="aboutImg" alt="">

        <div class="card-body">
          <div class="row justify-content-center">
            <h2 class="lifedi-color">
              ความเป็นมา
            </h2>
          </div>
          <div class="row">
            <div id="content" class="m-lg-5 m-md-3 m-sm-2 p-2">
              <p id="paragraph">
                ศูนย์จิตวิทยาพัฒนาการและความสัมพันธ์ระหว่างวัย (Psychology Center for Life-Span Development and
                Intergeneration)
                ได้รับทุนจากโครงการสร้างเสริมพลังจุฬาฯ ก้าวสู่ศตวรรษที่ 2 โดยมีวัตถุประสงค์หลักของโครงการมี 2 ข้อ ดังนี้
              </p>
              <div id="sub-paragraph">
                <ol>
                  <li>
                    เพื่อสร้างความเป็นเลิศด้านวิชาการให้แก่จุฬาลงกรณ์มหาวิทยาลัย
                    จากความแข็งแกร่งของศาสตร์ด้านจิตวิทยาพัฒนาการ
                    (Developmental Psychology) โดยการผลิตงานวิจัยด้านจิตวิทยาพัฒนาการจากความร่วมมือกับนานาชาติ
                    และเผยแพร่
                    องค์ความรู้ด้านจิตวิทยาที่มีคุณภาพสูงแก่สาธารณะในระดับชาติและนานาชาติ
                  </li>
                  <li>
                    เพื่อเป็นศูนย์กลางการให้บริการด้านจิตวิทยาพัฒนาการแก่สังคมในระดับประเทศและระดับเอเชียตะวันออกเฉียงใต้
                    ในการผลิต
                    และเผยแพร่นวัตกรรมการให้บริการทางจิตวิทยาที่มีคุณภาพ มีหลักฐานเชิงประจักษ์สนับสนุน
                    สร้างพันธมิตรเครือข่ายด้านงาน
                    จิตวิทยาพัฒนาการเพื่อสร้างประโยชน์และสอดรับกับความต้องการของสังคมได้อย่างยั่งยืน
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </div>
    </mat-card>
  </div>
</div>

<!-- <div class="bgImg">
  <div class="container">
    <div class="row mt-5 justify-content-center text-center">
      <div class="col-lg-2 col-md-6 col-sm-12">
        <img src="../../../assets/Chulalongkorn_University_Alt_Logo.svg.png" alt="" class="Img">
      </div>
    </div>
  </div>
</div> -->

<div class="container justify-content-center py-3">
  <div class="row mt-5">
    <div class="col">
      <h2 class="topic text-left">
        กรรมการศูนย์
      </h2>
    </div>
  </div>

  <!-- mobile size -->
  <div class="d-none d-block d-sm-block d-md-none" style="padding-bottom: 10px">
    <div class="row mt-3 justify-content-center text-center">
      <div *ngFor="let item of directorList" class="col-6">
        <img [src]="item.IMAGE_NAME" alt="" class="rounded-circle my-4" style="width: 70px; height: 70px;">
        <p class="text-center" style="font-size: smaller; margin: 0 0 0 0;">{{item.NAME}}</p>
        <p class="text-center" style="font-size: smaller;">{{item.JOB_TITLE}}</p>
      </div>
    </div>
  </div>
  <!-- mobile size -->


  <!-- desktop size -->
  <div style="padding-bottom: 10px"
    class="d-none d-xl-block d-lg-block d-md-block d-lg-none d-xl-none d-xxl-none d-xxl-block">
    <div class="row mt-5 justify-content-center text-center">
      <div *ngFor="let item of directorList" class="col-lg-4 col-md-6 col-sm-12">
        <img [src]="item.IMAGE_NAME" alt="" class="rounded-circle mt-5 mb-4" id="personImg">
        <p class="mb-3" style="font-size: large;">{{item.NAME}}</p>
        <p class="" style="font-size: large;">{{item.JOB_TITLE}}</p>
      </div>
    </div>
  </div>

  <!-- desktop size -->

  <!-- <div class="row mt-5">
    <div class="col">
      <h2 class="topic">
        นักจิตวิทยา
      </h2>
    </div>
  </div>
  <div class="row mt-5 justify-content-center text-center">
    <div *ngFor="let item of psychologistList" class="col-lg-4 col-md-6 col-sm-12">
      <img [src]="item.imgUrl" alt="" class="rounded-circle" id="personImg">
      <p id="personName">{{item.name}}</p>
    </div>
  </div> -->
</div>

<lifedi-footer></lifedi-footer>
